import { FC } from 'react';
import { WeeeIcon } from '@/components/common/Icon';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { Props } from './types';

const More: FC<Props> = props => {
  let { trackingParams, as: Tag = 'a', moreLink, getTrackingParams } = props;
  const { commonClick } = useClickActionT2();

  return (
    <Tag
      aria-label={`explore more`}
      href={moreLink}
      className="w-full h-full flex items-center justify-center"
      onClick={() => {
        let _trackingParams = trackingParams;
        if (getTrackingParams) {
          _trackingParams = getTrackingParams();
        }
        commonClick({
          mod_nm: _trackingParams?.mod_nm,
          mod_pos: _trackingParams?.mod_pos,
          sec_nm: _trackingParams?.sec_nm || null,
          sec_pos: _trackingParams?.sec_pos ?? null,
          co: {
            target_nm: 'explore_more',
            ..._trackingParams.co
          },
          ctx: _trackingParams.ctx
        });
      }}>
      <div className="w-16 h-16 border border-solid border-surface-100-hairline rounded-full flex items-center justify-center">
        <WeeeIcon type="iconrightarrow" className="text-surface-100-fg-default" style={{ fontSize: 42 }} />
      </div>
    </Tag>
  );
};

export default More;
